export default __webpack_public_path__ + "static/media/6e85c35f9fc7860d.21ed44884ca4f56d19d9b5b66c6e41a1.svg";